module.exports = __webpack_public_path__ + "media/svg/vi-6b5c07f8.svg";